"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _themes = require("../../themes");

var _styles = require("../../helpers/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  "input": "input__input___tU1e3",
  "gray-view": "input__gray-view___3wXkL",
  "white-view": "input__white-view___2COWi",
  "is-invalid": "input__is-invalid___3MprW",
  "is-focused": "input__is-focused___YMLV_",
  "small-size": "input__small-size___1ngAt",
  "medium-size": "input__medium-size___2c1zr",
  "large-size": "input__large-size___1q4DA"
};

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "inputRef", void 0);

    _this.inputRef = null;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isAutoFocused && this.inputRef) {
        this.inputRef.focus();
      }
    }
  }, {
    key: "createClassName",
    value: function createClassName() {
      var _classnames;

      var _this$props = this.props,
          view = _this$props.view,
          className = _this$props.className,
          compileWithTheme = _this$props.compileWithTheme,
          isInvalid = _this$props.isInvalid,
          isFocused = _this$props.isFocused,
          size = _this$props.size;
      return compileWithTheme((0, _classnames2["default"])(styles.input, (0, _styles.getViewClassName)(styles, view), (0, _styles.getSizeClassName)(styles, size), (_classnames = {}, _defineProperty(_classnames, styles['is-focused'], isFocused), _defineProperty(_classnames, styles['is-invalid'], isInvalid), _classnames), className));
    }
    /* :: handleChange: SyntheticInputEvent<HTMLInputElement> => void */

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;

      if (onChange) {
        onChange(event);
      }
    }
    /* :: handleFocus: SyntheticInputEvent<HTMLInputElement> => void */

  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    }
    /* :: handleBlur: SyntheticInputEvent<HTMLInputElement> => void */

  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;

      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          type = _this$props2.type,
          isDisabled = _this$props2.isDisabled,
          value = _this$props2.value,
          placeholder = _this$props2.placeholder,
          maxLength = _this$props2.maxLength,
          name = _this$props2.name;
      return React.createElement("input", {
        type: type,
        maxLength: maxLength,
        className: this.createClassName(),
        disabled: isDisabled,
        placeholder: placeholder,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        value: value,
        name: name,
        ref: function ref(element) {
          _this2.inputRef = element;
        }
      });
    }
  }]);

  return Input;
}(React.Component);

exports.Input = Input;

_defineProperty(Input, "defaultProps", {
  type: 'text',
  view: 'gray',
  size: 'm',
  value: '',
  isInvalid: false,
  isDisabled: false,
  isFocused: false,
  isAutoFocused: false
});

var _default = (0, _themes.withTheme)(Input);

exports["default"] = _default;